import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const currencyFmt = (v) => `${(v / 1000).toFixed(0)}k€`;

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white dark:bg-slate-900 border rounded-lg shadow-lg px-3 py-2 text-xs">
      <p className="font-semibold mb-1">{label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} style={{ color: p.color }}>
          {p.name}: {p.value?.toLocaleString("es-ES", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} €
        </p>
      ))}
    </div>
  );
}

/** Gráfico de evolución: Presupuesto vs Gasto Real por año, leído directamente del desglose anual. */
export function AnnualEvolutionChart({ records, height = 260 }) {
  if (!records?.length) return null;
  const data = records
    .filter((r) => r.budget !== null || r.expenses !== null)
    .map((r) => ({ year: String(r.year), Presupuesto: r.budget, "Gasto Real": r.expenses }));
  if (!data.length) return null;

  return (
    <div className="w-full" data-testid="annual-evolution-chart">
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis dataKey="year" tick={{ fontSize: 11, fill: "#64748b" }} />
          <YAxis tickFormatter={currencyFmt} tick={{ fontSize: 11, fill: "#64748b" }} width={48} />
          <Tooltip content={<ChartTooltip />} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="Presupuesto" fill="#64748b" radius={[3, 3, 0, 0]} />
          <Bar dataKey="Gasto Real" fill="#ef4444" radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
